import { connect } from "react-redux";

// Component
import Admin from "./Admin";

// Actions

import { loginProfileCreatedReset } from "../../custom_modules/Login/loginActions";
import {
  inviteMember,
  clearMemberInvited,
} from "../../custom_modules/Members/membersActions";
import { updateFirstLogin } from "../../custom_modules/SignUp/signUpActions";
import {
  activateOrganizationSubscription,
  updateOrganizationSubscription,
} from "../../custom_modules/Subscription/subscriptionActions";

// Store props to map with current state
const mapStateToProps = (state) => ({
  selectedOrganization: state.organization.selectedOrganization,
  // orgDetails: state.currentSubscriptionPlan.orgDetails,
  profile: state.profile,
  userRole: state.organization.selectedOrganization?.role,
  isInviteLoading: state.member.inviteMemberLoading,
  memberInvited: state.member.memberInvited,
});

// Actions prop to dispatch
const mapDispatchToProps = (dispatch) => ({
  loginProfileCreatedReset: () => dispatch(loginProfileCreatedReset()),
  onInviteMember: (values) => dispatch(inviteMember(values)),
  clearMemberInvited: () => dispatch(clearMemberInvited()),
  updateFirstLogin: () => dispatch(updateFirstLogin()),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(Admin);
